import { Button } from "@/components/ui/button";
import { AlertTriangle, Clock, ArrowRight } from "lucide-react";
import { track } from "@/lib/analytics";
export function UrgencyBanner() {
  const handleClick = () => {
    track('urgency_banner_click', { action: 'quote_request' });
  };

  return (
    <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 px-4">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-5 w-5" />
          <span className="font-medium">Beperkte tijd: Extra subsidie beschikbaar voor 2025!</span>
          <Clock className="h-4 w-4 ml-2" />
        </div>
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={handleClick}
          className="bg-white text-orange-600 hover:bg-gray-100"
        >
          Profiteer nu <ArrowRight className="h-4 w-4 ml-1" />
        </Button>
      </div>
    </div>
  );
}